import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { isBrowser } from "react-device-detect";
import { getAuthorizedBranchIds } from "../utils/authHelper";
import AdmissionFormBuilder from "../components/newAdmissionForm/AdmissionFormBuilder";
import AdmissionsTabHeader from "../components/admissionprocess/AdmissionsTabHeader";

const FETCH_GLOBALS = gql`
  query ($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      globalBranches {
        id
        branch_name
      }
    }
    getFormFieldTypes {
      id
      form_field_type
    }
  }
`;

class AdmissionFormBuilderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  render() {
    if (Cookies.get("token") == undefined) {
      this.props.history.push("/login");
      return null;
    }

    const globals = this.props.globals;
    const loading = globals.loading;
    const error = globals.error;

    if (error !== undefined) {
      alert("Server Error. " + error.message);
      return null;
    }

    return (
      <div className={Cookies.get("toggle") || "wrapper"}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser === true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <AdmissionsTabHeader />
            <Container fluid>
              {loading ? (
                <Container>
                  <Row className="my-2">
                    <Col>
                      <div className="spinner-border text-primary text-center loading-img-center"></div>
                    </Col>
                  </Row>
                </Container>
              ) : (
                <>
                  {(() => {
                    let globalsData = globals.globals;
                    
                    // Filter branches based on user level
                    if (
                      Cookies.get("userlevel") != "1" &&
                      Cookies.get("userlevel") != "2"
                    ) {
                      const authorizedIds = getAuthorizedBranchIds();
                      let globalBranches = [];
                      if (globalsData && globalsData.globalBranches) {
                         globalsData.globalBranches.forEach((item) => {
                           if (authorizedIds.includes(String(item.id))) {
                             globalBranches.push(item);
                           }
                         });
                      }
                      globalsData = { ...globalsData, globalBranches };
                    }

                    const fieldTypes = globals.getFormFieldTypes || [];

                    return (
                      <AdmissionFormBuilder
                        branches={globalsData?.globalBranches || []}
                        fieldTypes={fieldTypes}
                      />
                    );
                  })()}
                </>
              )}
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(
  compose(
    graphql(FETCH_GLOBALS, {
      options: () => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
        },
        fetchPolicy: "network-only"
      }),
      name: "globals",
    })
  )(AdmissionFormBuilderPage)
);
